export function validatePhoneNumber(input_str) {
  let regex = new RegExp(/^\+(?:[0-9] ?){6,14}[0-9]$/);

  return regex.test(input_str);
}

export const forceNumeric = (e) => {
  e.target.value = e.target.value.replace(/[^\d]/, '');
};
